  <div>
    <!-- {{db.side_menu}} -->
    <div [class.hover]="hover_menu" [ngClass]="(db.side_menu) ?'Menu-pos':'Menu__pos'">
      <!-- {{db.side_menu}} -->
      <ion-content class="bg" (mouseenter)="db.side_menu == false ? (db.side_menu = true && hover_menu = true) : null"   (mouseleave)="hover_menu == true ? (db.side_menu = true && hover_menu = false) : null"  [ngClass]="db.ismobile?'bg__mobile':'bg'">
          <ion-list class="side-menu"> <!-- *ngIf="!db.ismobile" -->
              <ion-menu-toggle translate *ngFor="let page of menu.menu_items_list" auto-hide="false">
                  <!-- <ion-item lines="full" [routerDirection]="'root'" (click)="openPage(page)" lines="none" [ngClass]="{'active': (menu.active_menu == page.label)}">
                      <ion-icon src="{{page.icon}}"></ion-icon>
                      <div class="title">{{page.label}}</div>
                      </ion-item> -->
                      <!-- [ngClass]="{'active': (menu.active_menu == page.label)} -->
                  <div (click)="openPage(page)" [class.active]="menu.active_menu == page.label"
                      class="p0 m_header mouse" [class.m__header]="!db.side_menu">
                      <!-- [ngClass]="db.side_menu?'p0 m_header mouse':'p0 m__header mouse'" -->
                      <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}"></ion-icon>
                      <ion-icon class="Selected__icon" *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
                      <p *ngIf="db.side_menu" class="p0 hover_title title">{{page.label}}</p>
                      <ion-icon class="forwd__icon" *ngIf="!db.ismobile && menu.active_menu == page.label && db.side_menu" src="{{page.forwd_icon}}"></ion-icon>
                  </div>
              </ion-menu-toggle>
              <ion-menu-toggle translate auto-hide="false">
                  <div (click)="logout()" class="p0 m_header mouse" [class.m__header]="!db.side_menu">
                      <ion-icon slot="start" src="assets/collapes-menu/logout.svg"></ion-icon>
                      <p *ngIf="db.side_menu" class="p0 title hover_title">Logout</p>
                  </div>
              <!--    <ion-item lines="none" (click)="logout()">
                      <ion-icon slot="start" src="/assets/Side-menu/log-out.svg"></ion-icon>
                      <div class="title">Logout</div>
                      </ion-item> -->
              </ion-menu-toggle>
          </ion-list>
          <!-- <ion-list class="side-menu" *ngIf="db.ismobile">
              <ion-menu-toggle translate *ngFor="let page of menu.menu_items_list" auto-hide="false">
                  <div (click)="openPage(page)" [ngClass]="{'active': (menu.active_menu == page.label)}"
                      class="p0 m_header mouse" >
                      <ion-icon *ngIf="menu.active_menu != page.label " src="{{page.icon}}"></ion-icon>
                      <ion-icon *ngIf="menu.active_menu == page.label" src="{{page.whiteicon}}"></ion-icon>
                      <p class="p0 title">{{page.label}}</p>
                  </div>
              </ion-menu-toggle>
              <ion-menu-toggle translate auto-hide="false">
                  <div (click)="logout()" class="p0 m_header mouse">
                      <ion-icon slot="start" src="/assets/New-side-menu/Log-out.svg"></ion-icon>
                      <p class="p0 title">Logout</p>
                  </div>
              </ion-menu-toggle>
          </ion-list> -->
      </ion-content>
      <ion-footer class="mouse" *ngIf="!db.ismobile">
          <ion-toolbar>
                  <ion-item lines="none" (click)="db.side_menu = !db.side_menu">
                      <ion-icon *ngIf="db.side_menu" src='assets/collapse-left.svg'></ion-icon>
                      <ion-icon *ngIf="!db.side_menu" src='assets/collapse-right.svg'></ion-icon>
                      <div *ngIf="db.side_menu" class="title">Collapse Sidebar</div>
                  </ion-item>
          </ion-toolbar>
      </ion-footer>
    </div>
  </div>
